import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export default function HumiditySensorNode(props) {
    const { data } = props;
    const v = parseFloat(data?.liveValue ?? 0);
    const config = data?.config || {};
    const w = data?.width || 50;
    const h = data?.height || 50;
    const cx = w / 2, cy = h / 2;
    return (
        <BaseScadaNode {...props}>
            <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: 'block' }}>
                <circle cx={cx} cy={cy} r={Math.min(w, h) / 2 - 4} fill="#1E293B" stroke="#3B82F6" strokeWidth={2} />
                {/* Droplet shape */}
                <path d={`M ${cx},${cy - 12} Q ${cx + 9},${cy - 4} ${cx + 9},${cy + 2} Q ${cx + 9},${cy + 10} ${cx},${cy + 12} Q ${cx - 9},${cy + 10} ${cx - 9},${cy + 2} Q ${cx - 9},${cy - 4} ${cx},${cy - 12}`}
                    fill="#3B82F6" opacity={0.7} />
                <text x={cx} y={cy + 5} textAnchor="middle" fill="#fff" fontSize={9} fontWeight="bold">
                    {isNaN(v) ? '--' : `${v.toFixed(0)}%`}
                </text>
            </svg>
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
